// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__z6ZDO","subheader":"ReorderModal_subheader__2w41z","listWrap":"ReorderModal_listWrap__o3tn0"};